import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: "[whatappsTo]",
})
export class WhatappsToDirective {
  @Input("whatappsTo") phoneNumber: string;

  @HostListener("click", ["$event"])
  onClick(event: any): void {
    event.stopPropagation();
    //ToDo:check + or 6 
    this.phoneNumber = this.phoneNumber.replace("+", "");
    let firstTwoLettter = this.phoneNumber.substring(0, 2);
    if (firstTwoLettter == "01") {
      window.location.href = `https://wa.me/6${this.phoneNumber}`;
    }else{
      window.location.href = `https://wa.me/${this.phoneNumber}`;
    }
    // if(firstTwoLettter=="60"){
    //   window.location.href = `https://wa.me/${this.phoneNumber}`;
    // }else{
    //   if(firstTwoLettter=="01"){
    //     window.location.href = `https://wa.me/6${this.phoneNumber}`;
    //   }else{
    //     window.location.href = `https://wa.me/${this.phoneNumber}`;
    //   }
    // }
  }
}
